/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue';
import VueI18n from 'vue-i18n';

export const defaultLocale = 'en';


import { layoutLocale } from '@/layouts/locale';
import { authLocale } from '@/modules/auth/locale';
import {homePageLocale} from "@/modules/home-page/locale";
import {faqLocale} from "@/modules/faq/locale";
import { collaboratorsLocale } from "@/modules/collaborators/locale";
Vue.use(VueI18n);
const locale = localStorage.getItem("lang") || defaultLocale;


const options = {
    locale,
    fallbackLocale: 'en',
    messages: {
        vi: {
            layout: layoutLocale.vi,
            auth: authLocale.vi,
            home: homePageLocale.vi,
            faq: faqLocale.vi,
            collaborators: collaboratorsLocale.vi
        },
        en: {
            layout: layoutLocale.en,
            auth: authLocale.en,
            home: homePageLocale.en,
            faq: faqLocale.en,
            collaborators: collaboratorsLocale.en
        },
        jp: {
            layout: layoutLocale.jp,
            auth: authLocale.jp,
            home: homePageLocale.jp,
            faq: faqLocale.jp,
            collaborators: collaboratorsLocale.jp
        },
        ru: {
            layout: layoutLocale.ru,
            auth: authLocale.ru,
            home: homePageLocale.ru,
            faq: faqLocale.ru,
            collaborators: collaboratorsLocale.ru
        },
        ko: {
            layout: layoutLocale.ko,
            auth: authLocale.ko,
            home: homePageLocale.ko,
            faq: faqLocale.ko,
            collaborators: collaboratorsLocale.ko
        },
        zh: {
            layout: layoutLocale.zh,
            auth: authLocale.zh,
            home: homePageLocale.zh,
            faq: faqLocale.zh,
            collaborators: collaboratorsLocale.zh
        },
    },
};

const i18n = new VueI18n(options);

export default i18n;
